import { render, staticRenderFns } from "./TraineeResources.vue?vue&type=template&id=8ff58782&"
import script from "./TraineeResources.vue?vue&type=script&lang=js&"
export * from "./TraineeResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports